import { TechTableInfoModalComponent } from './../../../../../../shared/tech-table-info-modal/tech-table-info-modal.component';
import {
  TechTableInfoItemModel,
  TechTableInfoModel,
} from './../../../../../../core/models/tech-table-info.model';
import { Utils } from './../../../../../../utils/utils';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { CurrencyPipe, DoublePipe, DashEmptyPipe } from '@techrules/pipelib';
import { SessionService } from '@tech-services/session.service';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from '@techrules/portallib';
import internal from 'events';

@Component({
  selector: 'tech-datagrid-trades',
  templateUrl: './datagrid-trades.component.html',
  styleUrls: ['./datagrid-trades.component.scss'],
})
export class DatagridTradesComponent implements OnInit {
  @Input() dataSource: any;
  public isMovil: boolean;
  public colsTrades = [];
  public dateFormat = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');

  bgColors = Utils.LogoNameFirstColor;

  constructor(
    private deviceService: DeviceDetectorService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private sessionService: SessionService,
    private datePipe: DatePipe,
    private doublePipe: DoublePipe,
    private currencySymbolPipe: CurrencyPipe,
    private dashEmptyPipe: DashEmptyPipe
  ) {}

  ngOnInit() {
    this.isMovil = this.deviceService.isMobile();
    this.initTableColums();
  }

  @HostListener('window:resize') onresize() {
    this.isMovil = this.deviceService.isMobile();
    this.initTableColums();
  }

  /**
    Función para crear las columnas en las tablas
  */
  initTableColums() {
    if (this.isMovil) {
      this.colsTrades = [
        {
          dataField: 'ProductName',
          width: '50%',
          cssClass: 'td-250',
          cellTemplate: 'templateMobile',
          hidingPriority: 0,
        },
      ];
    } else {
      this.colsTrades = [
        {
          dataField: 'ProductName',
          caption: this.translate.instant('k000036'),
          width: '100%',
          cellTemplate: 'templateName',
          hidingPriority: 1,
        },
        {
          type: 'detailExpand',
        },
      ];
    }
  }

  /**
    Función para abrir popup del detalle modo mobile
  */
  openDetail(item) {
    let items: TechTableInfoItemModel[] = [];
    items.push(new TechTableInfoItemModel('k000999', item.TradeName));

    items.push(
      new TechTableInfoItemModel(
        'k002802',
        this.datePipe.transform(item.ValueDate, this.dateFormat)
      )
    );

    items.push(
      new TechTableInfoItemModel(
        'k000306',
        this.currencySymbolPipe.transform(item.Amount, item.Currency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k001810',
        this.doublePipe.transform(item.NumberOfShares)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k000048',
        this.currencySymbolPipe.transform(item.TradePrice, item.PriceCurrency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k000298',
        this.doublePipe.transform(item.ExhangeRate)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k002352',
        this.currencySymbolPipe.transform(item.Commisions, item.Currency)
      )
    );
    items.push(
      new TechTableInfoItemModel(
        'k000159',
        this.dashEmptyPipe.transform(item.Isin)
      )
    );
    const dialogData = new TechTableInfoModel(item.ProductName, items);

    const dialogRef = this.dialog.open(TechTableInfoModalComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      panelClass: [
        'dialogfluid-intocenter',
        'tranimate__animated',
        'tranimate__slideInRight',
      ],
      data: dialogData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  /*
      Función para colocar un border a la izquierda en modo Desktop
    */
  onRowExpanded(e) {
    const grid = e.component;
    const row = grid.getRowIndexByKey(e.key);
    const el = grid.getRowElement(row)[0];
    const detail = grid.getRowElement(row + 1)[0];
    el.classList.add('borderleft');
    detail.classList.add('borderleft');
    grid.selectRows(e.key);
  }
  /**
    Función para colocar un sombreado sobre la fila de la tabla
  */
  onRowClick(e) {
    const key = e.component.getKeyByRowIndex(e.rowIndex);
    const expanded = e.component.isRowExpanded(key);
    if (expanded) {
      e.component.collapseRow(key);
    } else {
      e.component.expandRow(key);
    }
  }
  /**
    Función
  */
  onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.command === 'expand') {
      e.cellElement.classList.remove('dx-datagrid-expand');
    }
  }
  /**
    Función
  */
  onRowCollapsed(e) {
    const grid = e.component;
    grid.selectRows(e.key);
  }

  getColorById(id): string {
    return Utils.getColorById(id);
  }
}
